function isNumeric(str: string): boolean {
	if (str.endsWith(".")) {
		str = str.replace(".", "");
	}
	return !isNaN(Number(str));
}
export { isNumeric };
